export function ShowFadeHidden(nomeClasse) {//aqui é para a animação de quando ve a seção pos-vantagens
    if (!nomeClasse) { return }

    const targetClass = document.getElementsByClassName(`${nomeClasse}`);
    for (let i = 0; i < targetClass.length; i++) {
        targetClass[i].style.opacity = '0';
    }

}